// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import { Brand } from 'models/propTypes/tile';

import Image from 'components/common/Image';
import { useKsNetwork } from 'hooks/kitchenSink';

const BrandLogo = ({ className, brand, fixedSize }) => {
  const format = fixedSize ? 'logoFixedSmallUrl' : 'logoSmallUrl';
  const urls = useKsNetwork(brand);
  const logoSrc = urls && urls[format];
  if (!logoSrc) return null;
  return (
    <Image
      alt="brand logo"
      src={logoSrc}
      className={className}
      data-testid="brand-logo"
    />
  );
};

BrandLogo.propTypes = {
  className: PropTypes.string,
  brand: Brand.isRequired,
  fixedSize: PropTypes.bool,
};

BrandLogo.defaultProps = {
  className: null,
  fixedSize: true,
};

export default React.memo(BrandLogo);
